import React from 'react';
import PropTypes from 'prop-types';
import { useMobileMediaQuery } from 'Utils/mediaQuery';

const mobileSize = 13;
const desktopSize = 20;

const PromoCodeIcon = ({ color, size }) => {
  const isMobile = useMobileMediaQuery();

  const iconSize = size || isMobile ? mobileSize : desktopSize;

  return (
    <svg
      width={iconSize}
      height={iconSize}
      viewBox="0 0 22 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.89997 0.0996094L19.799 1.51461L21.213 11.4146L12.021 20.6066C11.8334 20.7941 11.5791 20.8994 11.314 20.8994C11.0488 20.8994 10.7945 20.7941 10.607 20.6066L0.706971 10.7066C0.5195 10.5191 0.414185 10.2648 0.414185 9.99961C0.414185 9.73444 0.5195 9.48014 0.706971 9.29261L9.89997 0.0996094ZM10.607 2.22161L2.82797 9.99961L11.314 18.4846L19.092 10.7066L18.032 3.28161L10.607 2.22161ZM12.727 8.58561C12.3518 8.21033 12.1411 7.70139 12.1412 7.17076C12.1413 6.90801 12.1931 6.64785 12.2936 6.40513C12.3942 6.1624 12.5417 5.94186 12.7275 5.75611C12.9133 5.57035 13.1339 5.42302 13.3766 5.32251C13.6194 5.22201 13.8796 5.1703 14.1423 5.17035C14.673 5.17044 15.1818 5.38133 15.557 5.75661C15.9321 6.13189 16.1428 6.64083 16.1427 7.17146C16.1426 7.7021 15.9318 8.21096 15.5565 8.58611C15.1812 8.96126 14.6723 9.17196 14.1416 9.17187C13.611 9.17177 13.1021 8.96089 12.727 8.58561Z"
        fill={color}
      />
    </svg>
  );
};

PromoCodeIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
};

PromoCodeIcon.defaultProps = {
  color: '#18223D',
  size: null,
};

export default PromoCodeIcon;
